import { removeUserManagerEvents } from "app/infrastructure/auth/token-manager";
import { globalVar } from "app/infrastructure/universal";
import { useLogin } from "app/shell/hooks";
import { PropsWithChildren, useEffect } from "react";

type AuthProviderProps = PropsWithChildren & {
  authProvider: any;
}

export const AuthProvider = (props: AuthProviderProps) => {
  const { children } = props;
  const locationObj = globalVar('location');
  const searchParams = new URLSearchParams(locationObj.search);

  const isCodeAuthCallback = locationObj && searchParams.has('code') && searchParams.has('state');
  const { isSignedIn, redirectUrl, getSigninResponse, login, logout, isLogoutRoute, processLogout } = useLogin();
  const { isAnonymous } = props.authProvider;

  useEffect(() => {
    if (isCodeAuthCallback) {
      getSigninResponse();
    }
  }, [isCodeAuthCallback]);

  useEffect(() => {
    if (isAnonymous) {
      return () => undefined;
    }
    return () => removeUserManagerEvents();
  }, []);

  useEffect(() => {
    if (isAnonymous) {
      return;
    }
    !isSignedIn && !isCodeAuthCallback && !redirectUrl && !isLogoutRoute && login();
    if (isLogoutRoute) {
      isSignedIn ? logout() : processLogout();
    }
  }, [isSignedIn, isCodeAuthCallback, redirectUrl]);

  return (isSignedIn && !isLogoutRoute || !isSignedIn && isLogoutRoute || isAnonymous) ? children : null;
};
